<template>
    <div>
        <van-popup v-model="show" :closeable="isCloseable" @close="onClose" @chooseOrg="chooseOrg">
            <div class="selectOrg_wrap">
                <div class="search_wrap">
                    <van-search v-model="leagueName" shape="round" show-actionplaceholder="请输入搜索关键词" />
                    <van-button color="#66b1ff" @click="searchLeague()">搜索</van-button>
                </div>
                <van-list
                        v-model="loading"
                        :finished="finished"
                        finished-text="没有更多了"
                        @load="onLoad"
                >
                    <van-cell :title="item.leagueFullName" v-for="item in leagueList" :key="item.leagueId" @click="chooseOrg(item)">
<!--                        <template #right-icon>-->
<!--                            <van-button color="#66b1ff" @click="chooseOrg(item)">选择</van-button>-->
<!--                        </template>-->
                    </van-cell>
                </van-list>
            </div>
        </van-popup>
    </div>
</template>

<script>
    import {mapState} from 'vuex'
    import cons from '../cons.vue'
    import Toast from "vant/es/toast";
    export default {
        name: "selectOrgOne",
        props: {
            leagueTypeId: {
                type: [String, Number],
                default: '01TZB,00DJZTZB'
            },
            show:{
                default:false
            }
        },
        data() {
            return {
                dialogVisible: true,
                leagueName: '',
                leagueList: [],

                loading: false,
                finished: false,

                curPage: 1,
                rowsPrePage: 2,
                totalRows: 3,

                isshow: false,

                isCloseable:true,
                iscloseoverlay:false,
            }
        },
        created() {
            this.fetchData(1)
        },
        computed: {
            ...mapState({
                userId: state => state.user.userId,
                leagueId: state => state.league.leagueId,
                curUser: state => state.user,
                curLeague: state => state.league,
                curParams: state => state.commonparams,
            }),
            queryParams() {
                if ('/selectOrg' in this.curParams) {
                    return this.curParams['/selectOrg']
                }
                return {}
            },
            showPre() {
                //return false
                return this.curPage != 1
            },

            showNext() {
                //return false
                return this.curPage != this.totalPage
                // if(this.leagueList){
                //     if(this.leagueList.length<this.rowsPrePage){
                //         return false
                //     }else {
                //         return true
                //     }
                // }else {
                //     return false
                // }

            },
            startRow() {
                return parseInt((this.curPage - 1) * this.rowsPrePage + 1)
            },
            endRow() {
                let start = this.startRow
                let yu = this.rowsPrePage
                if (this.curPage == this.totalPage)
                    yu = this.totalRows % this.rowsPrePage == 0 ? this.rowsPrePage : this.totalRows % this.rowsPrePage

                return parseInt(start + yu - 1)
            },
            totalPage() {

                if (this.totalRows <= this.rowsPrePage) {
                    return 1
                }
                let yu = this.totalRows % this.rowsPrePage
                if (yu == 0) {
                    return this.totalRows / this.rowsPrePage
                }
                return (parseInt(this.totalRows / this.rowsPrePage)) + 1
            },

        },
        methods: {
            onLoad() {
                this.loading = true
                if (this.curPage * this.rowsPrePage < this.totalRows) {
                    this.curPage++
                    this.fetchData(this.curPage)
                } else {
                    this.finished = true
                }
            },
            chooseOrg(row) {
                this.$emit('chooseOrg', row)
            },
            searchLeague() {
                this.finished = false
                this.fetchData(1)

            },

            fetchData(page) {
                let self = this

                let param = new FormData()
                // param.append('currLeagueId', this.leagueId)
                // param.append('currUserId', this.userId)
                param.append('leagueName', this.leagueName)
                param.append('leagueTypeId', this.leagueTypeId)
                if (page != undefined && page != "") {
                    this.curPage = page
                    param.append('pageNum', page)
                } else {
                    param.append('pageNum', this.curPage)
                }
                this.loading = true

                this.PF('/public/getpage401', param, {baseURL: cons.u}).then((response) => {
                    this.loading = false
                    console.log("response.status:" + response.status)
                    if (response.status == 200) {
                        if (response.data.retCode === 1000) {
                            this.loading = false

                            if (this.curPage == 1) {
                                this.leagueList = response.data.results.leagueList;
                            } else {
                                this.leagueList = this.leagueList.concat(response.data.results.leagueList)
                            }

                            this.totalRows = response.data.results.totalNumber
                            this.rowsPrePage = response.data.results.pageNumber
                        } else {
                            self.$dialog.alert({
                                message: response.data.retMsg,
                                theme: 'round-button',
                            })
                            // Toast(response.data.retMsg)
                        }
                    } else {
                        self.$dialog.alert({
                            message: '获取数据发生异常.' + response.status,
                            theme: 'round-button',
                        })

                        // Toast('获取数据发生异常.' + response.status)
                    }
                })
                    .catch((error) => {
                        console.log(error)
                    });
            },


            onClose(){
                this.$emit('close', true)
            },

        },

    }
</script>

<style scoped>
    .van-popup{
        width: 95%;
        height: 80%;
        border-radius: 5px;
        background-color: #eeedf0;
    }
    .selectOrg_wrap{
        width: 100%;
    }
    .search_wrap{
        padding: 60px 20px 0 10px;
        display: flex;
        justify-content: space-between;
        align-items: center;

    }
    .search_wrap .van-search{
        background-color: transparent;
        flex: 0 0 80%;
    }
    .selectOrg_wrap .van-list{
        width: 95%;
        margin: 10px auto;
        border-radius: 5px;
    }
    /deep/ .selectOrg_wrap .van-button--normal{
        height: 30px;
        width: 80px;
        border-radius: 5px;
    }
    .selectOrg_wrap .van-list .van-cell{
        border-bottom: 1px solid #ebedf0;
    }
    .selectOrg_wrap .van-list .van-cell__title{
        padding-left: 10px;
        line-height: 30px;
    }

</style>
